var m = require('mithril');

var choices = require('../libs/choices');
var heading = require('../components/heading');
var key = require('../libs/keybindings');
var modal = require('../layout/components/modal');
var loaders = require('../layout/components/loaders');
var buttonElement = require('../components/button');

var Model = require('../libs/Model');
var alarmProfileForm = Object.assign(require('../../../../models/alarms/AlarmProfile'), Model);
var triggerForm = require('./models/trigger');

var triggerTypes = {
  hi: 'High Limit',
  lo: 'Low Limit',
  boolean: 'Boolean'
};

var oninit = function (vnode) {
  var ctrl = vnode.state;

  ctrl.init = function () {
    if (m.route.param('id') && (m.route.param('id') !== 'new')) {
      loaders.requestWithLoader({
        method : 'GET',
        url: '/api/v1/alarmprofile/' + m.route.param('id'),
        loader: 'main'
      })
      .then(function (res) {
        alarmProfileForm.initForm.call(alarmProfileForm, res);
        m.redraw()
      });
    } else {
      alarmProfileForm.initForm.call(alarmProfileForm, {});
    }

    loaders.requestWithLoader({
      url: '/api/v1/group/',
      method: 'GET'
    })
    .then(function (groups)  {
      ctrl.groups = groups.map(function (group, idx) {
        return {key: group.name, value: group['@rid']}
      })
    });
  }

  ctrl.save = function () {
    return alarmProfileForm.save()
    .then(function (pointProfileRecord) {
      if (pointProfileRecord && pointProfileRecord['@rid']) {
        alarmProfileForm.initForm.call(alarmProfileForm, pointProfileRecord);
        m.route.set('/alarmprofile/' + pointProfileRecord['@rid'].slice(1));
        m.redraw();
      } else {
        ctrl.init();
      }
    })
  };

  key('enter', 'pointProfileEditor', ctrl.save.bind(ctrl));
  key.setScope('pointProfileEditor');
  
  // modal.on('closed', ctrl.init)

  ctrl.init();

  // Triggers
  ctrl.addTrigger = function () {
    modal.vm.title('Create New Trigger');
    modal.vm.body = triggerForm.view;
    modal.vm.open();
    triggerForm.initForm();
    modal.vm.buttons([
      {
        label: "Submit",
        class: "dib ",
        func: async function () {
          try {
            await triggerForm.validate.call(triggerForm, triggerForm.form);
            await ctrl.saveTrigger()
          } catch (e) {
            triggerForm.errors = [];
            e.forEach(error=>{
              triggerForm.errors.push(error)
            })
            throw new Error()
          }
        },
        showError: true
      }
    ])
  };

  ctrl.saveTrigger = function (){
    var triggerID;
    alarmProfileForm.form.triggers().sort(function (a,b) { return b.id - a.id })
    if (alarmProfileForm.form.triggers().length) {
      triggerID = alarmProfileForm.form.triggers().length + 1;
    } else {
      triggerID = 1;
    }
    alarmProfileForm.form.triggers().push(triggerForm.toJSON.call(triggerForm));
    modal.vm.close();
  }

  ctrl.editTrigger = function (elementIndex) {
    modal.vm.title('Edit Trigger');
    triggerForm.initForm(alarmProfileForm.form.triggers()[elementIndex])
    modal.vm.body = triggerForm.view
    modal.vm.open();

    modal.vm.buttons([
      {
        label: "Submit",
        class: "dib ",
        func: function () {
          alarmProfileForm.form.triggers()[elementIndex] = triggerForm.toJSON.call(triggerForm);
          modal.vm.close();
        }
      }
    ])
  };

  ctrl.toggleHour = function toggleHour (hour) {
    var found = alarmProfileForm.form.excludedHours().findIndex(function (el) {
      return el == hour
    });

    if (found > -1) {
      alarmProfileForm.form.excludedHours().splice(found, 1);
    } else {
      alarmProfileForm.form.excludedHours().push(hour);
    }
  }

  ctrl.toggleDayOfWeek = function toggleHour (day) {
    var found = alarmProfileForm.form.excludedDaysOfWeek().findIndex(function (el) {
      return el == day
    });

    if (found > -1) {
      alarmProfileForm.form.excludedDaysOfWeek().splice(found, 1);
    } else {
      alarmProfileForm.form.excludedDaysOfWeek().push(day);
    }
  }
};

function onremove (vnode) {
  modal.off('closed', this.init);
  key.setScope('home');
  alarmProfileForm.initForm.call(alarmProfileForm, {});
}


function formView (ctrl) {
  return m("form", {role:"form"}, [
    m("div", {class:"form-group"}, [
      m("name", {for:"element-name-input"}, "Name"),
      m("input.form-control", {
        type:"text", 
        autocomplete: 'off',
        onchange: function (ev){ctrl.name(ev.target.value)},
        value: ctrl.name(),
      }),
    ])
  ]);
}

var view = function (vnode) {
  var ctrl = vnode.state;
  if(!alarmProfileForm.record){
    return m('div')
  }
  return m('div.container.mb5', [
    m('div.flex.justify-between.mb3.pb1.bb.bw1.b--mid-gray.near-white', [
      m('div.f-subheadline', [
          m('div.mr2.dib-ns', [
            m(m.route.Link, {href:'/'}, 'Home'),
            ' / '
          ]),
          m('div.mr2.dib-ns', [
            m('span', alarmProfileForm.record['@rid'] ? 'Edit ' + alarmProfileForm.record.name : 'New Alarm Profile')
          ])
      ])
    ]),
    m(heading, {label: "Alarm Profile Name"}),
    m("form", [
      m("div.mb2",[
        m("input", {
          type: 'text',
          value: alarmProfileForm.form.name(), 
          oninput: function (ev){alarmProfileForm.form.name(ev.target.value)}
        })
      ])
    ]),

    m(heading, {label: "Notify Resets"}),
    m("form", [
      m("div.mb2",[
        m("select.form-control", {value: alarmProfileForm.form.notifyReset(), onchange: function (ev){alarmProfileForm.form.notifyReset(ev.target.value)}}, [
          m("option", {value:0}, 'False'),
          m("option", {value:1}, 'True')
        ])
      ])
    ]),
    m(heading, {label: "Excluded Days"}),
    m('div.flex.justify-between', [
      m('div.flex', [
        m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedDaysOfWeek().find(function (el) { return el == 0 }) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleDayOfWeek(0)},
            },
            'Sun'
          )
        ]),
        m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedDaysOfWeek().find(function (el) { return el == 1 }) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleDayOfWeek(1)},
            },
            'Mon'
          )
        ]),
        m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedDaysOfWeek().find(function (el) { return el == 2 }) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleDayOfWeek(2)},
            },
            'Tue'
          )
        ]),
        m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedDaysOfWeek().find(function (el) { return el == 3 }) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleDayOfWeek(3)},
            },
            'Wed'
          )
        ]),
        m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedDaysOfWeek().find(function (el) { return el == 4 }) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleDayOfWeek(4)},
            },
            'Thu'
          )
        ]),
        m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedDaysOfWeek().find(function (el) { return el == 5 }) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleDayOfWeek(5)},
            },
            'Fri'
          )
        ]),
        m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedDaysOfWeek().find(function (el) { return el == 6 }) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleDayOfWeek(6)},
            },
            'Sat'
          )
        ])
      ])
    ]),
    m(heading, {label: "Excluded Hours"}),
    m('div.flex.justify-between', [
      m('div.flex', [
        m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedHours().find(function (el) { return el == 0}) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleHour(0)},
            },
            12
          )
        ]),        
        Array(11).fill(1).map(function (k, idx) {
        return m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedHours().find(function (el) { return el == idx + 1 }) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleHour(idx + 1)},
            },
            idx + 1
          )
        ])
      })]),
      m('div.v-mid.tc.ba.bw1.pa3.ma1.mr0', 'AM'),
    ]),
    m('div.flex.justify-between.mb2', [
      m('div.flex', [
        m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedHours().find(function (el) { return el == 12}) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleHour(12)},
            },
            12
          )
        ]),
        Array(11).fill(1).map(function (k, idx) {
        return m('div.dt.pv1.mr1', [
          m('div.dtc.v-mid.tc.ba.bw1.pa3.' + (alarmProfileForm.form.excludedHours().find(function (el) { return el == idx + 13}) > -1 ? 'bg-blue' : ''), 
            {
              onclick: function () {ctrl.toggleHour(idx + 13)},
            },
            idx + 1
          )
        ])
      })]),
      m('div.v-mid.tc.ba.bw1.pa3.ma1.mr0', 'PM'),
    ]),
    m('form', {role:'form'}, [
      // alarmProfileForm.errorView.call(alarmProfileForm),
      m('div', {class:'form-group'}, [
        m(heading, {label: 'Triggers', class: 'f2 pb1 pt2'}),
        m('table.w-100.f3.pt2.pb3', [
          m('thead', [
            m('tr', [
              m('th.tc.v-btm.bw1.ph2', [
                m('p.ma0.tc', 'Type')
              ]),
              m('th.tc.v-btm.bw1.ph2', [
                m('p.ma0.tc', 'Trip Delay')
              ]),
              m('th.tc.v-btm.bw1.ph2', [
                m('p.ma0.tc', 'Reset Delay')
              ]),
              m('th.tc.v-btm.bw1.ph2', [
                m('p.ma0.tc', 'Scalar')
              ])
            ])
          ]),
          m('tbody', [
            Array.prototype.map.call(alarmProfileForm.form.triggers() || [], function (trigger, idx) {
              return m('tr', [
                m('td.tc.f2.bb-0.bl-0.b--dotted.bw1', triggerTypes[trigger.triggerType]),
                m('td.tc.f2.bb-0.bl-0.b--dotted.bw1', trigger.tripDelay),
                m('td.tc.f2.bb-0.bl-0.b--dotted.bw1', trigger.resetDelay),
                m('td.tc.f2.bb-0.bl-0.b--dotted.bw1.blue', trigger.scalar),
                m('td.tc.f2.br-0.bb-0.bl-0.b--dotted.bw1', [
                  m('i.ion-ios-compose.blue', {
                    onclick: function () {
                      ctrl.editTrigger.call(ctrl, idx);
                    },
                    style:{marginRight:'1em'}, 
                  }),
                  m('i.ion-ios-trash.red', {onclick: function (e) {alarmProfileForm.form.triggers().splice(idx, 1)}})
                ])
              ])
            }),
            m('tr', [
              m('td.tc.f2.br-0.bb-0.bl-0.b--dotted.bw1'),
              m('td.tc.f2.br-0.bb-0.bl-0.b--dotted.bw1'),
              m('td.tc.f2.br-0.bb-0.bl-0.b--dotted.bw1'),
              m('td.tc.f2.br-0.bb-0.bl-0.b--dotted.bw1'),
              m('td.tc.f2.br-0.bb-0.bl-0.b--dotted.bw1', [
                m('i.ion-plus.blue', {
                  onclick: ctrl.addTrigger.bind(ctrl)
                })
              ])
            ])
          ])
        ])
      ]),
      m(heading, {label: "Escalation Receivers"}),    
      function(){
        if(!ctrl.groups){
          return m('div')
        }else{
          return m('div.mb2', [
            m(choices, {
              data: ctrl.groups,
              value: alarmProfileForm.form.escalationReceivers
            })
          ])  
        }
      }(),
      m(heading, {label: "Escalation Delay (Seconds)"}),
      m("form", [
        m("div.mb2",[
          m("input", {
            type: 'number',
            value: alarmProfileForm.form.escalationDelay(), 
            oninput: function (ev){alarmProfileForm.form.escalationDelay(ev.target.value)}
          })
        ])
      ]),
      m(heading, {label: "Send Continuous Notifications"}),
      m("form", [
        m("div.mb2",[
          m("select.form-control", {value: alarmProfileForm.form.sendContinuousNotifications(), onchange: function(ev){alarmProfileForm.form.sendContinuousNotifications(ev.target.value)}}, [
            m("option", {value:0}, 'False'),
            m("option", {value:1}, 'True')
          ])
        ])
      ]),
      m(heading, {label: "Continuous Notification Interval (Seconds)"}),
      m("form", [
        m("div.mb2",[
          m("input", {
            type: 'number',
            value: alarmProfileForm.form.continuousNotificationInterval(), 
            oninput: function(ev){alarmProfileForm.form.continuousNotificationInterval(ev.target.value)}
          })
        ])
      ]),
      m(buttonElement, {label:'Save', class: 'mv3',func: ctrl.save.bind(ctrl)})
    ])
  ])
};

module.exports = {oninit: oninit, onremove: onremove, view: view};
